/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useTranslation } from 'react-i18next'; // ✅ Import translation hook
import './Footer.css';
import { Link } from 'react-router-dom';
import Logo from './../../assets/logos/LogoColour.svg'; 
import X from '../../assets/icons/ig.svg';
import D from '../../assets/icons/telegram.svg';
import W from '../../assets/icons/whats.svg';
import E from '../../assets/icons/em.svg';

const Footer: React.FC = () => {
  const { t } = useTranslation(); // ✅ Enable translation support

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-logo">
            <img src={Logo} alt="Logo" className="logo" />
          </div>
        </div>

        <div className="footer-right">
          <div className="footer-section">
            <h3 className="footer-title">{t("connect_now")}</h3> {/* ✅ Translate */}
            <ul>
              <li>
                <a className="socail-link-with-icon" href="https://www.instagram.com/razum.uae" target="_blank" rel="noopener noreferrer">
                  <img src={X} alt="Instagram" className="icon" /> Instagram
                </a>
              </li>
              <li>
                <a className="socail-link-with-icon" href="https://t.me/razumuae" target="_blank" rel="noopener noreferrer">
                  <img src={D} alt="Telegram" className="icon" /> Telegram
                </a>
              </li>
              <li>
                <a className="socail-link-with-icon" href="https://wa.me/message/KDMFDNPQYTU2G1" target="_blank" rel="noopener noreferrer">
                  <img src={W} alt="Telegram" className="icon" /> WhatsApp
                </a>
              </li>
              <li>
                <a className="socail-link-with-icon" href="mailto:support@myrazum.com" target="_blank" rel="noopener noreferrer">
                  <img src={E} alt="Telegram" className="icon" /> Email
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t("platform")}</h3> {/* ✅ Translate */}
            <ul>
              <li className="footer-link"><a href="/events">{t("events")}</a></li> {/* ✅ Translate */}
              <li className="footer-link"><a href="/masters">{t("masters")}</a></li> {/* ✅ Translate */}
              <li className="footer-link"><a href="/programs">{t("programs")}</a></li> {/* ✅ Translate */}
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t("company")}</h3> {/* ✅ Translate */}
            <ul>
              <li className="footer-link"><a href="mailto:george@myrazum.com">{t("become_partner")}</a></li> {/* ✅ Translate */}
              <li className="footer-link"><a href="mailto:george@myrazum.com">{t("work_with_us")}</a></li> {/* ✅ Translate */}
              <li className="footer-link"><a href="mailto:support@myrazum.com">{t("contact")}</a></li> {/* ✅ Translate */}
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-left-bottom">
        <p className="footer-copyright">{t("ip1")}</p> 
        <p className="footer-copyright"> {t("ip2")}</p>
        <p className="footer-copyright"> {t("ip3")}</p>
          <p className="footer-copyright">© {t("all_rights_reserved")}</p> {/* ✅ Translate */}
        </div>
        <div className="footer-right-bottom">
        <p><Link to="/terms-and-conditions">{t("terms_conditions")}</Link></p>
         <p><Link to="/privacy-policy">{t("privacy_policy")}</Link></p>
         <p><Link to="/cookies-policy">{t("cookies_policy")}</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
